import * as THREE from 'three';
import { lerp } from './utils/utils';

function createParticle(){
    
    const geometry = new THREE.BufferGeometry();
    const count = 1000;
    const positions = new Float32Array(count * 3);
    const colors = new Float32Array(count * 3);

    const vector = new THREE.Vector3();

    for(let i = 0; i < count; i++) {

        const i3 = i * 3;

        vector.x = (Math.random() - 0.5) * 2;
        vector.y = (Math.random() - 0.5) * 2;
        vector.z = (Math.random() - 0.5) * 2;
        vector.setLength(1);
        vector.multiplyScalar(lerp(50, 80, Math.random()));

        positions[i3] = vector.x;
        positions[i3+1] = vector.y;
        positions[i3+2] = vector.z;
        
        //
        colors[i3] = 1;
        colors[i3+1] = 1;
        colors[i3+2] = 1;
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
    geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))

    const material = new THREE.PointsMaterial({
        size: 0.1,
        sizeAttenuation: true,
        //transparent:true
    })

    material.vertexColors = true;

    return new THREE.Points(geometry, material);
}

export {createParticle};